import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { guardRoute } from '../auth/guard.ts'
import { NAV_PATHS } from '../navigation/paths.ts'
import { rootRoute } from './root.tsx'

// The account: the password and the one contact detail its owner may correct. Why it is not under
// `/me`, why only the user menu reaches it, and no role: apps/frontend/docs/account-settings.md
export const settingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: NAV_PATHS.settings,
  beforeLoad: ({ context, location }) =>
    guardRoute({ queryClient: context.queryClient, currentPath: location.href }),
  staticData: { opensOnHero: true },
  component: lazyRouteComponent(() => import('../pages/settings.tsx')),
})
